<payee-popup
  width="560px"
  [heading]="'CASES_TABLE.START_PAYMENT_CHOICE.TITLE' | translate"
>
  <ng-template #payeePopupDescriptionTemplate>
    <span color="grey-medium">
      {{ "CASES_TABLE.START_PAYMENT_CHOICE.DESCRIPTION" | translate }}
      <a
        color="blue-king"
        href="https://help.payee.tech/hu/articles/6228749-garantalt-hogy-az-adosom-fizet-es-a-plusz-koltsegeimet-is-fedezi"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ "CASES_TABLE.START_PAYMENT_CHOICE.MORE_INFO" | translate }}
      </a>
    </span>
  </ng-template>

  <mat-radio-group
    class="payment-method-selector flex column alt-theme"
    color="primary"
    [(ngModel)]="paymentMethod"
  >
    <mat-radio-button
      value="card"
      data-testid="payment-method-card"
    >
      <div class="flex vcenter">
        <div class="flex column grow1">
          <div class="payment-method-title">
            {{ "CASES_TABLE.START_PAYMENT_CHOICE.CARD_TITLE" | translate }}
          </div>
          <div class="payment-method-description">
            {{ "CASES_TABLE.START_PAYMENT_CHOICE.CARD_DESCRIPTION" | translate }}
          </div>
        </div>
        <img
          src="assets/shared/global-images/partner-logos/barion.svg"
          width="151"
          alt="barion"
        />
      </div>
    </mat-radio-button>
    <mat-radio-button
      value="transfer"
      data-testid="payment-method-transfer"
    >
      <div class="payment-method-title">
        {{ "CASES_TABLE.START_PAYMENT_CHOICE.TRANSFER_TITLE" | translate }}
      </div>
      <div class="payment-method-description">
        {{ "CASES_TABLE.START_PAYMENT_CHOICE.TRANSFER_DESCRIPTION" | translate }}
      </div>
    </mat-radio-button>
    @if (data.canPayWithCredit) {
      <mat-radio-button
        value="credit"
        data-testid="payment-method-credit"
      >
        <div class="payment-method-title">
          {{ "CASES_TABLE.START_PAYMENT_CHOICE.CREDIT_TITLE" | translate }}
        </div>
        <div class="payment-method-description">
          {{ "CASES_TABLE.START_PAYMENT_CHOICE.CREDIT_DESCRIPTION" | translate }}
        </div>
      </mat-radio-button>
    }
  </mat-radio-group>

  <ng-template #payeePopupSubmitTemplate>
    <button
      type="button"
      payee-button
      width="max"
      [loading]="loading()"
      [disabled]="loading()"
      (click)="submit()"
    >
      @switch (paymentMethod) {
        @case ("transfer") {
          {{ "CASES_TABLE.START_PAYMENT_CHOICE.SUBMIT_TRANSFER" | translate }}
        }
        @case ("credit") {
          {{ "CASES_TABLE.START_PAYMENT_CHOICE.SUBMIT_CREDIT" | translate }}
        }
        @default {
          {{ "CASES_TABLE.START_PAYMENT_CHOICE.SUBMIT_CARD" | translate }}
        }
      }
    </button>
  </ng-template>
</payee-popup>
